module.exports = __webpack_public_path__ + "static/media/iconFilter.2f42d040.svg";